import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  webapp: defineAsyncComponent(() => import("/app/layouts/webapp.vue").then(m => m.default || m))
}